import { FormattedDate, useIntl } from 'react-intl';
import { ReactElement } from 'react';

const msPerMinute = 60 * 1000;
const msPerHour = msPerMinute * 60;
const msPerDay = msPerHour * 24;
const msPerWeek = msPerDay * 7;
const msPerMonth = msPerDay * 30;

export interface PoolFormattedRelativeTimeProps {
    value: Date;
}

export const PoolFormattedRelativeTime = (props: PoolFormattedRelativeTimeProps): ReactElement => {
    const { formatRelativeTime } = useIntl();

    const current = Date.now();
    const elapsed = current - props.value.getTime();

    if (elapsed < msPerMinute) {
        return <>{formatRelativeTime(-Math.floor(elapsed / 1000), 'second')}</>;
    } else if (elapsed < msPerHour) {
        return <>{formatRelativeTime(-Math.floor(elapsed / msPerMinute), 'minute')}</>;
    } else if (elapsed < msPerDay) {
        return <>{formatRelativeTime(-Math.floor(elapsed / msPerHour), 'hour')}</>;
    } else if (elapsed < msPerWeek) {
        return <>{formatRelativeTime(-Math.floor(elapsed / msPerDay), 'day')}</>;
    } else if (elapsed < msPerMonth) {
        return <>{formatRelativeTime(-Math.floor(elapsed / msPerWeek), 'week')}</>;
    }
    return <FormattedDate value={props.value} year="numeric" month="2-digit" day="2-digit" />;
};
